import {Component, Input, OnInit} from '@angular/core';
import {BerlinBrandenBurgKurzBericht} from "../../../../../../../../model/vorhersagen/rbb-document";

@Component({
  selector: 'app-berlin-brandenburg-kurz-bericht',
  templateUrl: './berlin-brandenburg-kurz-bericht.component.html',
  styleUrls: ['./berlin-brandenburg-kurz-bericht.component.css', '../../../wetterbericht.component.css']
})
export class BerlinBrandenburgKurzBerichtComponent {

  @Input()
  berlinBrandenburgKurzBericht?: BerlinBrandenBurgKurzBericht;


}
